import React from 'react'

const LocationIcon = (): JSX.Element => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 7.5C10.6193 7.5 9.5 8.61929 9.5 10C9.5 11.3807 10.6193 12.5 12 12.5C13.3807 12.5 14.5 11.3807 14.5 10C14.5 8.61929 13.3807 7.5 12 7.5ZM10.5 10C10.5 9.17157 11.1716 8.5 12 8.5C12.8284 8.5 13.5 9.17157 13.5 10C13.5 10.8284 12.8284 11.5 12 11.5C11.1716 11.5 10.5 10.8284 10.5 10Z"
      // fill="#565B5D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 10.1389C18 13.3433 16.2134 15.7262 12.6402 20.1995C12.466 20.4175 12.2875 20.6406 12.1048 20.869L12 21L11.8952 20.869C11.7125 20.6406 11.534 20.4175 11.3598 20.1995C7.7866 15.7262 6 13.3433 6 10.1389C6 6.74847 8.68629 4 12 4C15.3137 4 18 6.74847 18 10.1389ZM17 10.1389C17 11.6045 16.5778 12.8927 15.6425 14.4513C14.8137 15.8326 13.6164 17.3725 12 19.3984C10.3836 17.3725 9.18633 15.8326 8.35747 14.4513C7.42222 12.8927 7 11.6045 7 10.1389C7 7.27906 9.26003 5 12 5C14.74 5 17 7.27906 17 10.1389Z"
      // fill="#565B5D"
    />
  </svg>
)

export default LocationIcon
